/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Train_ThisInputs */

const en_us2_plan_train_this = /** @type {(inputs: Plan_Train_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train this one`)
};

const pt_br2_plan_train_this = /** @type {(inputs: Plan_Train_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar este`)
};

const es_419_plan_train_this = /** @type {(inputs: Plan_Train_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenar este`)
};

const pt_pt2_plan_train_this = /** @type {(inputs: Plan_Train_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar este`)
};

const fr_fr2_plan_train_this = /** @type {(inputs: Plan_Train_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire celle-ci`)
};

const de_de2_plan_train_this = /** @type {(inputs: Plan_Train_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses trainieren`)
};

const it_it2_plan_train_this = /** @type {(inputs: Plan_Train_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai questo`)
};

/**
* | output |
* | --- |
* | "Train this one" |
*
* @param {Plan_Train_ThisInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_train_this = /** @type {((inputs?: Plan_Train_ThisInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Train_ThisInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_train_this(inputs)
	if (locale === "es-419") return es_419_plan_train_this(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_train_this(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_train_this(inputs)
	if (locale === "de-DE") return de_de2_plan_train_this(inputs)
	if (locale === "it-IT") return it_it2_plan_train_this(inputs)
	return en_us2_plan_train_this(inputs)
});
export { plan_train_this as "plan.train_this" }